import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseVariant2 = lazyWithPreload(
  () => import('./PurchaseVariant2'),
)
